import { Link } from 'react-router-dom';
import { liveMatches } from '@/mocks/sports';

export default function LiveMatchList() {
  const liveMatchesFiltered = liveMatches.filter((m) => m.status === 'live');

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              实时直播
            </h2>
            <p className="text-sm text-foreground-500 mt-1">精彩赛事正在直播中</p>
          </div>
          <Link
            to="/category/football"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-xs w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {liveMatchesFiltered.map((match) => (
            <Link
              key={match.id}
              to={`/category/${match.category}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:shadow-md transition-all duration-200 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={match.thumbnail}
                  alt={`${match.homeTeam} vs ${match.awayTeam}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-primary-500 text-background-50 text-xs font-semibold px-2 py-0.5 rounded flex items-center gap-1">
                    <span className="w-1.5 h-1.5 bg-background-50 rounded-full animate-pulse"></span>
                    直播中
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="bg-black/60 text-white text-xs px-2 py-0.5 rounded">
                    {match.viewers.toLocaleString()} 人观看
                  </span>
                </div>
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-500 mb-2">{match.league}</p>
                <div className="flex items-center justify-between">
                  <div className="flex-1 text-center">
                    <p className="font-semibold text-foreground-900 text-sm">{match.homeTeam}</p>
                  </div>
                  <div className="px-3 flex items-center gap-1.5">
                    <span className="font-heading text-xl font-bold text-primary-500">{match.homeScore}</span>
                    <span className="text-xs text-foreground-400">:</span>
                    <span className="font-heading text-xl font-bold text-foreground-700">{match.awayScore}</span>
                  </div>
                  <div className="flex-1 text-center">
                    <p className="font-semibold text-foreground-900 text-sm">{match.awayTeam}</p>
                  </div>
                </div>
                <p className="text-xs text-primary-500 font-medium mt-2 text-center">{match.minute}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}